import { render, staticRenderFns } from "./InfoChart.vue?vue&type=template&id=6ff2f495&scoped=true"
import script from "./InfoChart.vue?vue&type=script&lang=js"
export * from "./InfoChart.vue?vue&type=script&lang=js"
import style0 from "./InfoChart.vue?vue&type=style&index=0&id=6ff2f495&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2f495",
  null
  
)

export default component.exports